import { render, staticRenderFns } from "./PdmGestao.vue?vue&type=template&id=10ab76d4&scoped=true"
import script from "./PdmGestao.vue?vue&type=script&lang=js"
export * from "./PdmGestao.vue?vue&type=script&lang=js"
import style0 from "./PdmGestao.vue?vue&type=style&index=0&id=10ab76d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab76d4",
  null
  
)

export default component.exports